// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"41179eef","453":"87e5cee0","625":"8fda704a"}[chunkId] + ".chunk.js";
};